import { useQuery } from '@tanstack/react-query';
import { NHTSAPackageApi } from 'api';

export function useGetNHTSAPackage(id) {
  return useQuery({
    queryKey: ['nhtsa-package', id],
    queryFn: () => NHTSAPackageApi.getPackage(id),
  });
}
